document.addEventListener('DOMContentLoaded', function() {
	const externalLinks = document.querySelectorAll('.js-external-link');
	const svgCode = '<svg xmlns="http://www.w3.org/2000/svg" width="12.325" height="12.338" viewBox="0 0 12.325 12.338"><g transform="translate(-458.5 -2417.162)"><path d="M874,902H862V890h4.5v1H863v10h10v-3.5h1V902Z" transform="translate(-403.5 1527.5)" fill="#e76503"/><g transform="translate(454.496 2407.162)"><path d="M8.389,18.514l-.688-.7,7.794-7.671.688.7Z" transform="translate(0 -0.003)" fill="#e76503"/><path d="M16.5,16h-.981V10.981H10.5V10h5.513a.491.491,0,0,1,.491.491Z" transform="translate(-0.174 0)" fill="#e76503"/></g></g></svg>';
	const debug = false;

	debug ? console.log(externalLinks) : false;

	externalLinks.forEach(function(element) {
		element.innerHTML += svgCode;
	});
});
